/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react'
import { useMediaQuery } from 'react-responsive'
import { useSearch } from '@faststore/sdk'
import type { Facet } from '@faststore/sdk/dist/types'

import DynamicImages from '../CarouselBanner/DynamicImage'

type Props = {
  className: string
  promotionalBannerData?: TAllCmsPlp
  imageWidth: {
    desktop: number
    mobile: number
  }
  imageHeight: {
    desktop: number
    mobile: number
  }
  valueLoading?: 'eager' | 'lazy'
}

const BannerPlp = ({
  className,
  promotionalBannerData,
  imageWidth,
  imageHeight,
  valueLoading,
}: Props) => {
  const [allBanners, setBanners] = useState<TSectionValues[]>([])
  const {
    state: { selectedFacets, base },
  } = useSearch()

  const isSearchResult = base === '/s/'
  const edges = promotionalBannerData?.allCmsPlp?.edges
  const isDesktop = useMediaQuery({
    query: '(min-width: 1280px)',
  })

  const hasFacets = (facets: Facet[], slug: string) => {
    return facets?.some(({ value }) => value === slug)
  }

  useEffect(() => {
    setBanners([])
    edges?.forEach((edgeValue) => {
      edgeValue?.node?.sections.forEach((section) => {
        const hasCategory =
          hasFacets(selectedFacets, section.data?.slug) && !isSearchResult

        section.name === 'SearchBanner' && hasCategory && setBanners([section])
      })
    })
  }, [selectedFacets])
  if (!allBanners.length) {
    return null
  }

  return (
    <div className={`banner__container-${className}`}>
      {allBanners?.map(
        ({ data: { desktop, mobile, alt, link, slug } }, idx) => {
          const srcSet = isDesktop ? desktop?.srcSet : mobile?.srcSet
          const slugBanner = slug
          const idBanner = `${slugBanner} banner ${idx}`
          const imageValues = {
            href: srcSet,
            title: alt,
            id: idBanner,
            link,
          }

          return (
            <div key={idx}>
              <DynamicImages
                valueLoading={valueLoading}
                imageValues={imageValues}
                imageWidth={{
                  desktop: imageWidth.desktop,
                  mobile: imageWidth.mobile,
                }}
                imageHeight={{
                  desktop: imageHeight.desktop,
                  mobile: imageHeight.mobile,
                }}
              />
            </div>
          )
        }
      )}
    </div>
  )
}

export default BannerPlp
